import { useEffect, useState } from "react";
import userSelectors from "../../../redux/UserProfile/selectors";
import commonDashboardOperations from "../../../redux/CommonDashboard/operations";
import commonDashboardSelectors from "../../../redux/CommonDashboard/selectors";
import {operations} from 'redux/Navigation'
import { useSelector, useDispatch } from "react-redux";
import CommonDashboard from "./CommonDashboard";

const CommonDashboardContainer = () => {

  const [showUserManagementPopup, setshowUserManagementPopup] = useState(false);
  const hidePopup = () => {
    setshowUserManagementPopup(false);
  };
  const dispatch = useDispatch();
  const dispatchGetNewsAndAnnouncementDetails =
    commonDashboardOperations.dispatchGetNewsAndAnnouncementDetail(dispatch);

  const { userDetails, newsAndAnnouncementDetails, loading }: any = useSelector(
    (state) => ({
      userDetails: userSelectors.getUserDetails(state),
      newsAndAnnouncementDetails:
        commonDashboardSelectors.getNewsAndAnnouncementDetails(state),
        loading: commonDashboardSelectors.pageLoading(state)
    })
  );

  useEffect(() => {
    let reqData = {
      page: 0,
      pageSize: 0,
      sort: [
        {
          field: "string",
          direction: "string",
        },
      ],
      totalCount: 0,
    };
    dispatchGetNewsAndAnnouncementDetails(reqData);
  }, []);

  useEffect(() => {
    if (userDetails.emailId) {
      setshowUserManagementPopup(false);
    }
  }, [userDetails]);

  useEffect(() => {
    setshowUserManagementPopup(false);
  }, []);

  return(
      <CommonDashboard  
        newsAndAnnouncementDetails={newsAndAnnouncementDetails}
        showUserManagementPopup={showUserManagementPopup}
        hidePopup={hidePopup}
        loading={loading}
      />
  )
 }

export default CommonDashboardContainer;
